export default __webpack_public_path__ + "static/media/IC_safari_48x48.dae70222.png";